import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enUi from '../locales/en/ui.json';
import zhUi from '../locales/zh/ui.json';
import arUi from '../locales/ar/ui.json';

export { resolveAppLanguage, isRtlLocale } from './language';

export const LANGUAGE_STORAGE_KEY = 'gofar_language';

const VALID_APP_LANGUAGES = new Set(['en', 'ar', 'zh']);

/** Clears localStorage but keeps the user's UI language (logout / auth reset). */
export function clearLocalStoragePreservingLanguage() {
  let lng = null;
  try {
    const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (saved && VALID_APP_LANGUAGES.has(saved)) {
      lng = saved;
    }
  } catch {
    // ignore
  }
  try {
    localStorage.clear();
    if (lng) {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
    }
  } catch {
    // ignore
  }
}

function getInitialLanguage() {
  try {
    const saved = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (saved === 'zh' || saved === 'en' || saved === 'ar') {
      return saved;
    }
  } catch {
    // ignore
  }
  return 'en';
}

function applyDocumentLang(lng) {
  if (typeof document === 'undefined') return;
  if (lng === 'zh') {
    document.documentElement.lang = 'zh-CN';
  } else if (lng === 'ar') {
    document.documentElement.lang = 'ar';
  } else {
    document.documentElement.lang = 'en';
  }
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
}

const initialLng = getInitialLanguage();
applyDocumentLang(initialLng);

i18n.use(initReactI18next).init({
  resources: {
    en: {
      ui: enUi,
    },
    zh: {
      ui: zhUi,
    },
    ar: {
      ui: arUi,
    },
  },
  lng: initialLng,
  fallbackLng: 'en',
  ns: ['ui'],
  defaultNS: 'ui',
  interpolation: {
    escapeValue: false,
  },
});

export function setAppLanguage(lng) {
  applyDocumentLang(lng);
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
  } catch {
    // ignore
  }
  return i18n.changeLanguage(lng);
}

export default i18n;
